import { createSelector } from '@ngrx/store';
import { cartState } from '../root';
import { getCartTotalValue } from '../getCartTotalValue/get-cart-total-value.selector';

export const getCartTotalValueAfterDiscounts = createSelector(cartState, getCartTotalValue, (cart, cartTotalValue) => {
    const discountsTotalValue = cart.activatedVouchers.reduce((total, voucher) => total + (voucher.ActivatedOrderDiscount?.AmountApplied ?? 0), 0);

    return cartTotalValue - discountsTotalValue;
});
